export default __webpack_public_path__ + "static/media/Estimatic_Logo.0c35f523.svg";